import { render, staticRenderFns } from "./SignInRedirect.vue?vue&type=template&id=0c267912"
import script from "./SignInRedirect.vue?vue&type=script&lang=js"
export * from "./SignInRedirect.vue?vue&type=script&lang=js"
import style0 from "./SignInRedirect.vue?vue&type=style&index=0&id=0c267912&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports